import React from "react";
import { motion } from "framer-motion";

type SectionProps = {
  children: React.ReactNode;
  title?: string;
  eyebrow?: string;
  id?: string;
  className?: string;
  containerClassName?: string;
};

const baseSection = "relative w-full py-16 sm:py-20";
const baseContainer = "max-w-5xl mx-auto px-4";

export default function Section({
  children,
  title,
  eyebrow,
  id,
  className = "",
  containerClassName = ""
}: SectionProps) {
  const sectionClass = [baseSection, className].filter(Boolean).join(" ").trim();
  const containerClass = [baseContainer, containerClassName].filter(Boolean).join(" ").trim();

  return (
    <section id={id} className={sectionClass}>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.75, ease: [0.4, 0, 0.2, 1] }}
        className={containerClass}
      >
        {(eyebrow || title) && (
          <div className="mb-10">
            {eyebrow && (
              <p className="font-mono text-xs uppercase tracking-[0.4em] text-text-subtle">
                {eyebrow}
              </p>
            )}
            {title && (
              <h2 className="mt-3 text-3xl sm:text-4xl font-semibold text-primary">
                {title}
              </h2>
            )}
          </div>
        )}
        {children}
      </motion.div>
    </section>
  );
}

